import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { ModalLayoutModule } from '../modal-layout';

import { SyncStatusIconComponent } from './sync-status-icon.component';
import { SyncStatusBarComponent } from './sync-status-bar.component';
import { SyncButtonComponent } from './sync-button.component';
import { SyncForceButtonComponent } from './sync-force-button.component';
import { SyncAllForcesButtonComponent } from './sync-all-forces-button.component';

@NgModule({
    imports: [CommonModule, IonicModule, ModalLayoutModule, TranslateModule],
    exports: [SyncStatusIconComponent, SyncStatusBarComponent, SyncButtonComponent, SyncForceButtonComponent, SyncAllForcesButtonComponent],
    declarations: [
        SyncStatusIconComponent,
        SyncStatusBarComponent,
        SyncButtonComponent,
        SyncForceButtonComponent,
        SyncAllForcesButtonComponent
    ],
    providers: []
})
export class DataSyncModule {}
